import React, { ReactNode } from 'react';

import { cx } from '@travel/utils';

import styles from './timeLineSection.module.scss';

export enum PenaltyType {
  CANCELLATION_PENALTY,
  NO_SHOW_PENALTY,
}

type Props = {
  isOnly: boolean;
  isLast: boolean;
  color?: 'free' | 'partialPenalty' | 'fullPenalty';
  amount: string | ReactNode;
  deadLine: string | ReactNode;
  className?: string;
  iconClassName?: string;
  arrowClassName?: string;
  lineClassName?: string;
  cancellationPolicyClassName?: string;
  deadLineClassName?: string;
};

function TimeLineSection(props: Props) {
  const {
    isOnly,
    isLast,
    color = 'partialPenalty',
    amount,
    deadLine,
    className,
    iconClassName,
    arrowClassName,
    lineClassName,
    cancellationPolicyClassName,
    deadLineClassName,
    ...rest
  } = props;

  return (
    <div className={cx(styles.container, className)} {...rest}>
      {!isOnly && (
        <div>
          <div className={cx(styles.dot, styles[color], iconClassName)}>
            <span className={cx(styles.arrow, styles[color], arrowClassName)} />
          </div>
          {!isLast && <span className={cx(styles.line, styles[color], lineClassName)} />}
        </div>
      )}
      <div className={cx(styles.cancellationPolicyDescription, cancellationPolicyClassName)}>
        {deadLine && <div className={cx(styles.date, deadLineClassName)}>{deadLine}</div>}
        {amount}
      </div>
    </div>
  );
}

export default TimeLineSection;
